import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CheckoutCustomTaxExemptStatusState from "@sunSource/Store/Data/CheckoutCustomTaxExemptStatus/CheckoutCustomTaxExemptStatusState";
import { Draft } from "immer";

const initialState = {
    taxExemptStatus: "",
};

const reducer = {
    "Custom/CheckoutCustomTaxExemptStatus/update": (
        draft: Draft<CheckoutCustomTaxExemptStatusState>,
        action: { taxExemptStatus: string },
    ) => {
        draft.taxExemptStatus = action.taxExemptStatus;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
